import 'regenerator-runtime/runtime';
import { put, call, all } from 'redux-saga/effects';
import { searchNewRequestList, getKeyMetricsList, getFilterLatestActivitiesList } from './api';

import * as DashBoardActionType from './constants';
import * as NotifyActionType from '../Notification/constants';
import { takeLatest } from 'redux-saga';

export function* searchNewRequestListAsync(action) {
  const result = yield call(searchNewRequestList, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: DashBoardActionType.SEARCH_NEW_REQUEST_DASH_BOARD_LIST_SUCCESS,
      data: { data: result.data, params: action.params }
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* getKeyMetricsListAsync(action) {
  const result = yield call(getKeyMetricsList, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: DashBoardActionType.GET_KEY_METRICS_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* getFilterLatestActivitiesListAsync(action) {
  const result = yield call(getFilterLatestActivitiesList, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: DashBoardActionType.GET_LATEST_FILTER_ACTIVITIES_LIST_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback();
    }
  } else if (statusCode === 204) {
    yield put({
      type: DashBoardActionType.GET_LATEST_FILTER_ACTIVITIES_LIST_SUCCESS,
      data: []
    });
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR, data: result.data.error
    });
  }
}

export function* getLatestActivitiesWhenScrollDownAsync(action) {
  const result = yield call(getFilterLatestActivitiesList, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: DashBoardActionType.GET_LATEST_ACTIVITIES_WHEN_SCROLL_DOWN_SUCCESS,
      data: result.data
    });
    if (action.callback) {
      action.callback();
    }
  } else if (statusCode === 204) {
    yield put({
      type: DashBoardActionType.GET_LATEST_ACTIVITIES_WHEN_SCROLL_DOWN_SUCCESS,
      data: []
    });
  } else {
    yield put({
      type: NotifyActionType.NOTIFY_ERROR, data: result.data.error
    });
  }
}

export default function* WatchDashBoard() {
  yield all([
    takeLatest(DashBoardActionType.SEARCH_NEW_REQUEST_DASH_BOARD_LIST_ASYNC,searchNewRequestListAsync),
    takeLatest(DashBoardActionType.GET_KEY_METRICS_ASYNC, getKeyMetricsListAsync),
    takeLatest(DashBoardActionType.GET_LATEST_FILTER_ACTIVITIES_LIST_ASYNC, getFilterLatestActivitiesListAsync),
    takeLatest(DashBoardActionType.GET_LATEST_ACTIVITIES_WHEN_SCROLL_DOWN_ASYNC, getLatestActivitiesWhenScrollDownAsync)
  ]);
}



// WEBPACK FOOTER //
// ./src/Dashboard/saga.js